import React from 'react'
import SocialLinks from '../constants/socialLinks'
const Footer = () => {
  return (
    <footer className="footer">
      <div>
        <SocialLinks styleClass="footer-icons" />
        <p>
          &copy;2021-{new Date().getFullYear()} DevsrcBlog. All rights reserved.
        </p>
      </div>
    </footer>
  )
}

export default Footer
